/* Progressive enhancement: articles, links and native accordions work without JavaScript. */
(() => {
  function initialise(root) {
    if (root.dataset.directoryReady) return;
    root.dataset.directoryReady = 'true';
    const contents = root.querySelector('[data-page-contents]');
    const list = contents?.querySelector('ul');
    root.querySelectorAll('.inf-directory__chapter[id]').forEach((chapter) => {
      const title = chapter.querySelector('h2');
      if (!list || !title) return;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${chapter.id}`;
      link.textContent = title.textContent;
      item.append(link);
      list.append(item);
    });
    if (list?.children.length) contents.hidden = false;
    const search = root.querySelector('[data-faq-search]');
    if (!search) return;
    const status = root.querySelector('[data-faq-status]');
    const chapters = [...root.querySelectorAll('.inf-directory__chapter')];
    const filters = root.querySelector('[data-faq-filters]');
    const buttons = [...root.querySelectorAll('[data-faq-filter]')];
    let category = 'all';
    function filterQuestions() {
      const query = search.value.trim().toLocaleLowerCase();
      let count = 0;
      chapters.forEach((chapter) => {
        const inCategory = category === 'all' || chapter.dataset.faqCategory === category;
        let chapterCount = 0;
        chapter.querySelectorAll('details').forEach((item) => {
          const match = inCategory && item.textContent.toLocaleLowerCase().includes(query);
          item.hidden = !match;
          if (match) { count++; chapterCount++; }
        });
        chapter.hidden = chapterCount === 0;
        if (list) {
          const entry = [...list.querySelectorAll('a')].find((a) => a.getAttribute('href') === `#${chapter.id}`);
          if (entry) entry.parentElement.hidden = chapter.hidden;
        }
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.faqFilter === category)));
      status.textContent = query || category !== 'all'
        ? (count ? `${count} ${count === 1 ? 'question' : 'questions'} found.` : 'No matching questions in this category. Try another word or choose All topics.')
        : '';
    }
    if (filters) filters.hidden = false;
    buttons.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.faqFilter;
      filterQuestions();
    }));
    search.addEventListener('input', filterQuestions);
    filterQuestions();
  }
  document.querySelectorAll('.inf-directory').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.inf-directory').forEach(initialise));
})();
